var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clear_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clear_svg__\\u97F3\\u9891\\u7F16\\u8F91",
    transform: "translate(-621.000000, -8.000000)",
    stroke: "#5A5A5A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clear_svg__\\u6E05\\u9664",
    transform: "translate(621.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clear_svg__152188",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clear_svg__\\u7F16\\u7EC4",
    transform: "translate(10.000000, 9.079392) scale(-1, 1) rotate(-180.000000) translate(-10.000000, -9.079392) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3696612,12.5034492 L17.3696612,14.9542929 C17.3696612,16.7240846 15.997309,18.1587842 14.3044269,18.1587842 L3.06523433,18.1587842 C1.37235215,18.1587842 0,16.7240846 0,14.9542929 L0,3.20449133 C0,1.43469964 1.37235215,0 3.06523433,0 L7.3095732,0",
    id: "clear_svg__clear",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61185631,
    y1: 10.3786233,
    x2: 20,
    y2: 0.164307175,
    id: "clear_svg__\\u8DEF\\u5F84-4",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61185631,
    y1: 10.3786233,
    x2: 20,
    y2: 0.164307175,
    id: "clear_svg__\\u8DEF\\u5F84-4\\u5907\\u4EFD",
    strokeWidth: 2.5,
    transform: "translate(14.805928, 5.271465) scale(-1, 1) translate(-14.805928, -5.271465) "
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.db17b5a9.svg";
export { ForwardRef as ReactComponent };